export default {
  //api: "https://wvltb6omrc.execute-api.us-east-1.amazonaws.com/dev",
  api: "https://pfkm0qyyu4.execute-api.us-east-1.amazonaws.com/prod",
  elb_url: "https://streaming.studio4d.com/"
};
